'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _v = require('uuid/v4');

var _v2 = _interopRequireDefault(_v);

var _lrz = require('lrz');

var _lrz2 = _interopRequireDefault(_lrz);

var _mintUi = require('mint-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    options: {
      type: Object,
      default: function _default() {}
    },
    attrs: {
      type: Object,
      default: function _default() {
        accept: 'image/*';
      }
    },
    title: {
      type: String,
      default: ''
    },
    addBtnText: {
      type: String,
      default: ''
    },
    onSuccess: {
      type: Function,
      default: function _default() {
        return [];
      }
    },
    onPreUpload: {
      type: Function,
      default: function _default() {
        return true;
      }
    },
    images: {
      type: Array,
      default: null
    }
  },
  data: function data() {
    return {
      locked: false,
      imageList: null,
      isShowImageList: false,
      imageAction: ''
    };
  },
  mounted: function mounted() {
    if (this.images) {
      this.imageList = JSON.parse(JSON.stringify(this.images || {}));
    }
  },

  watch: {},
  computed: {},
  filters: {},
  methods: {
    onFileUpload: function onFileUpload(e, imageAction) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var files, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, image, id;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.locked) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _this.locked = true;

                _context.prev = 3;

                if (imageAction === 'init') {
                  _mintUi.Indicator.open({
                    text: '正在上传...',
                    spinnerType: 'snake'
                  });
                }

                _this.imageList = JSON.parse(JSON.stringify(_this.imageList || {}));

                if (imageAction === 'new' || imageAction === 'init') {
                  _this.options.query.fileKey = (0, _v2.default)();
                  _this.imageList = {};
                }

                files = _this.options.single ? e.target.files ? [e.target.files[0]] : [] : e.target.files;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 11;
                _iterator = files[Symbol.iterator]();

              case 13:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 24;
                  break;
                }

                file = _step.value;
                _context.next = 17;
                return (0, _lrz2.default)(file);

              case 17:
                image = _context.sent;
                id = (0, _v2.default)();

                _this.imageList[id] = {
                  progress: 0
                };
                _this.submitUpload(image, id);

              case 21:
                _iteratorNormalCompletion = true;
                _context.next = 13;
                break;

              case 24:
                _context.next = 30;
                break;

              case 26:
                _context.prev = 26;
                _context.t0 = _context['catch'](11);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 30:
                _context.prev = 30;
                _context.prev = 31;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 33:
                _context.prev = 33;

                if (!_didIteratorError) {
                  _context.next = 36;
                  break;
                }

                throw _iteratorError;

              case 36:
                return _context.finish(33);

              case 37:
                return _context.finish(30);

              case 38:
                _context.prev = 38;

                _this.locked = false;
                if (imageAction === 'init') {
                  _mintUi.Indicator.close();
                }
                return _context.finish(38);

              case 42:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3,, 38, 42], [11, 26, 30, 38], [31,, 33, 37]]);
      }))();
    },
    submitUpload: function submitUpload(file, id) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var options, key, _ref, data, msg;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                options = {
                  headers: {
                    'content-type': 'application/x-www-form-urlencoded'
                  },
                  onUploadProgress: function onUploadProgress(progressEvent) {
                    _this2.imageList[id].progress = progressEvent.loaded / progressEvent.total * 100 | 0;
                  }
                };


                for (key in _this2.options.query) {
                  file.formData.append(key, _this2.options.query[key]);
                }
                _context2.next = 5;
                return _this2.$axios.post(_this2.options.target, file.formData, options);

              case 5:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 8;
                  break;
                }

                _context2.t0 = {};

              case 8:
                _ref = _context2.t0;
                data = _ref.data;

                _this2.imageList = JSON.parse(JSON.stringify(_this2.imageList || {}));
                _this2.imageList[id].fileKey = data.fileKey;
                _this2.imageList[id].fileUrl = data.filePath && data.filePath[0] ? data.filePath[0] : '';
                _this2.onSuccess(Object.values(_this2.imageList));
                _context2.next = 21;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t1 = _context2['catch'](0);
                msg = '';

                if (_context2.t1 && _context2.t1.data && _context2.t1.data.msg) {
                  msg = _context2.t1.data.msg;
                }

                (0, _mintUi.Toast)({
                  message: msg || '网络请求出错',
                  position: 'bottom',
                  duration: 2000
                });

              case 21:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 16]]);
      }))();
    },
    onShowImage: function onShowImage() {
      this.isShowImageList = true;
    },
    onClose: function onClose() {
      this.imageAction = '';
      this.isShowImageList = false;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/uploader.vue
// module id = 236
// module chunks = 14